export const contactsData = {
    email: 'gangasystems2017@gmail.com',
    phone: '9952409557',
    address: '13/6-5, Thuraiyur Rd, Thirumurugan Nagar, Musiri, Tamil Nadu 621211 ',

    sheetAPI: ''
}